import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { colors, media } from '../styles/vars'
import arrowLeft from '../static/images/icons/arrow_left.png'

const Container = styled.div`
background-color:${colors.white};
width:${props => props.width ? props.width : 'auto'};
margin:0 auto;
text-align:center;
white-space:nowrap;
${
    media.desktop`
    width:auto;
    display:inline-block;
    `
}
`
const StyledLink = styled(Link) `
display:block;
padding:5px 0 2px;
&, &:hover, &:visited{
    color:${colors.black};
    text-decoration:none;
}
> *{
    display:inline-block;
    vertical-align:middle;
    cursor:pointer;
}

label {
    font-weight:700;
    font-size:2.6rem;
    margin-left:8px;
}
img{
    width:7px;
    display:initial !important;
}

${
    media.desktop`
    padding:5px 10px 2px;
    `
}
`
const ArticleLink = (props) => {
    return (
        <Container width={props.width}>
            <StyledLink to={`/article/${props.articleId}`}>
                <label>לכתבה המלאה</label>
                <img src={arrowLeft} alt="" />
            </StyledLink>
        </Container>
    )
}

export default ArticleLink;


// WEBPACK FOOTER //
// ./src/components/ArticleLink.jsx